import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the lists of internal recipients (ADR-149 points 5 and 6): all of them at once, with the internal
// users one can be given.

const lists = api.notifications["recipient-lists"];

type RecipientLists = InferResponseType<typeof lists.$get, 200>;
export type RecipientList = RecipientLists["items"][number];
export type RecipientCandidate = RecipientLists["candidates"][number];

const keys = { all: ["recipient-lists"] as const };

export const recipientListQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(lists.$get({}, { init: { signal } })),
    }),
};
